<template>
	<div ref="wrapper" class="cll-state-view-wrapper" v-if="!error && !loading">
		<slot></slot>
	</div>
	<div class="loading" v-else-if="loading">
		<slot name="loading">
			<div class="loading-item">
				<div class="loading-icon"></div>
				<div>{{ loadingText }}</div>
			</div>
		</slot>
	</div>
	<div class="error" v-else>
		<slot name="error">
			<div class="error-item">
				<div class="error-icon"></div>
				<div>{{ errorText ? errorText : `error` }}</div>
			</div>
		</slot>
	</div>
</template>

<script>
export default {
	name: 'CllStateView',
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		loadingText: {
			type: String,
			default: '加载中...',
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorText: {
			type: String,
		},
	},
};
</script>

<style scoped>
.cll-state-view-wrapper {
	width: 100vw;
	height: 100%;
	position: relative;
}

.loading {
	width: 100vw;
	height: 100px;
	z-index: 999999999;
	position: fixed;
	top: calc(50vh - 50px);
	left: 0;
	display: flex;
	flex-direction: row;
	text-align: center;
	align-items: center;
	justify-content: space-around;
}

@keyframes loadingRotate {
	from {
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

.loading-item {
	min-width: 100px;
	height: 100px;
	text-align: center;
	color: #aaa;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate3d(-50%, -50%, 0);
	z-index: 9999;
	margin: 0 auto;
	font-size: 13px;
}

.loading-icon {
	display: inline-block;
	margin-bottom: 10px;
	width: 25px;
	height: 25px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	border-top: 3px solid #aaa;
	border-right: 3px solid #aaa;
	border-bottom: 3px solid transparent;
	border-left: 3px solid #aaa;
	-webkit-animation: loadingRotate linear 0.48s infinite;
	-o-animation: loadingRotate linear 0.48s infinite;
	animation: loadingRotate linear 0.48s infinite;
}

.error {
	width: 100vw;
	height: auto;
	z-index: 999999999;
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: row;
	text-align: center;
	align-items: center;
	justify-content: space-around;
	padding-top: 20px;
}

.error-item {
	text-align: center;
	color: rgba(255, 92, 82, 1);
}
</style>
